<template>
  <v-container fluid>
    <v-layout column>
      <v-layout row align-center> <!-- row of filters and button -->
        <v-layout column>
          <v-layout row justify-space-between>
            <v-flex class="mr-2">
              <template>
                <v-flex>
                  <v-menu
                    ref="startDateMenu"
                    v-model="startDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator" slot-scope="{ on }">
                      <v-text-field
                        label="Start Date"
                        format="dddd, MM DD YYYY"
                        @change="value => startDate = value"
                        :value="dateFormatted(startDate)"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :show-current="endDate"
                      v-model="startDate"
                      @input="startDateMenu = false"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </template>
            </v-flex>
            <v-flex class="mr-2">
              <template>
                <v-flex>
                  <v-menu
                    ref="endDateMenu"
                    v-model="endDateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator" slot-scope="{ on }">
                      <v-text-field
                        label="End Date"
                        format="dddd, MM DD YYYY"
                        @change="value => endDate = value"
                        :value="dateFormatted(endDate)"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :show-current="startDate"
                      v-model="endDate"
                      @input="endDateMenu = false"
                      no-title
                      scrollable
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
              </template>
            </v-flex>
            <v-flex>
              <v-select
                label="Per Page"
                :items="limitOptions"
                v-model="limit"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex shrink class="mr-2">
              <v-select
                label="My Shifts / Available Shifts"
                :items="statusFilters"
                v-model="selectedStatusFilter"
              ></v-select>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-select
                label="Position"
                :items="positionFilters"
                item-text="name"
                item-value="id"
                v-model="selectedPositionFilter"
                :loading="positionsLoading"
                :disabled="positionsLoading"
                clearable
              ></v-select>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-autocomplete
                label="Location"
                :items="locationFilters"
                item-text="name"
                item-value="id"
                v-model="selectedLocationFilter"
                :loading="locationsLoading"
                :disabled="locationsLoading"
                clearable
              ></v-autocomplete>
            </v-flex>
            <v-flex shrink class="mr-2">
              <v-switch
                v-model="selectedTradeFilter"
                label="View Trades Only"
              ></v-switch>
            </v-flex>
          </v-layout>
          <!-- <v-layout row>
            <v-flex shrink class="mr-2">
              <v-select
                label="Bonus"
                :items="bonusFilterOptions"
                v-model="selectedbonusFilter"
                clearable
              ></v-select>
            </v-flex>
          </v-layout> -->
        </v-layout>
        <v-layout row>
          <v-btn @click="reGetRecords" color="primary">
            Update
          </v-btn>
        </v-layout>
      </v-layout>

      <v-divider />

      <FilterPresets :currentQuery="formattedQuery" @updateFilters="updateFilters" />

      <v-layout class="mb-2">
        <v-flex shrink>
          <a href="#" @click.prevent="goToMonth">Switch To Month View</a>
          <SetDefaultViewButton view="list" class="ml-3" />
        </v-flex>
      </v-layout>

      <v-flex v-if="shiftQueryPending">
        <v-progress-linear indeterminate>
        </v-progress-linear>
      </v-flex>

      <v-flex v-else>
        <v-layout column justify-center class="text-xs-center">
          <v-flex class="mb-2">
            <span class="subtle body">{{ `${ queryTotal } record${ queryTotal == 1 ? '' : 's' }` }} in this search</span>
          </v-flex>
          <v-layout row>
            <v-flex>
              <v-pagination
                v-model="page"
                :length="pageLength"
              >
              </v-pagination>
            </v-flex>
          </v-layout>
        </v-layout>
        <v-layout column v-if="events.length" class="mb-3">
          <h3 class="subheading mb-2">Your events</h3>
          <EventInList v-for="event in events" :key="`evt-${event.event_id}`" :event="event"/>
        </v-layout>
        <v-layout column>
          <v-flex v-for="(shift, i) in this.sortedShifts" :key="shift.id">
            <ShiftInList v-if="!hide(shift)" :index="i" :shift="shift" :class="maybeGrey(shift)"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import WeekView from '@/components/calendar/weekView.vue'
import MonthView from '@/components/calendar/monthView.vue'
import shiftOnMonth from '@/components/calendar/shiftOnMonth.vue'
import shiftOnWeek from '@/components/calendar/shiftOnWeek.vue'
import ShiftInList from '@/components/calendar/shift-in-list.vue'
import EventInList from '@/components/calendar/event-in-list.vue'
import inviteApi from '@/api/invites'
import collectionApi from '@/api/collections'
import FilterPresets from '@/components/calendar/filter-presets.vue'
import SetDefaultViewButton from '@/components/calendar/set-default-view-button.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    WeekView,
    MonthView,
    shiftOnMonth,
    shiftOnWeek,
    ShiftInList,
    EventInList,
    FilterPresets,
    SetDefaultViewButton,
  },
  created () {
    this.setUp()
  },
  watch: {
    'page': {
      handler(value) {
        if (value != this.$route.query.page) {
          this.reGetRecords()
        } else {
        }
        
      }
    }
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    workedDays: function() {
      return this.shifts.filter((shift) => {
        return shift.userId == this.user.id
      }).map(shift => this.$moment(shift.startDatetime).format("YYYY-MM-DD"));
      // will return a list of dates the employee works, like: [ "2019-10-29", "2019-10-31" ]
    },
    haveShifts: function () {
      return this.shifts.length > 0
    },
    availableManagers: function () {
      return []
    },
    computedOffset: function () {
      return this.limit * (this.page - 1)
    },
    pageLength: function () {
      return Math.ceil(this.queryTotal / this.limit)
    },
    formattedQuery: function () {
      if (this.selectedStatusFilter == 'assigned' || this.selectedStatusFilter == 'employee-all') {
        this.selectedEmployeeFilter = this.user.id
      } else {
        this.selectedEmployeeFilter = null
      }

      return {
        startDate: this.startDate,
        endDate: this.endDate,
        limit: this.limit,
        page: this.page,
        offset: this.computedOffset,
        statusFilter: this.selectedStatusFilter,
        positionFilter: this.selectedPositionFilter,
        locationFilter: this.selectedLocationFilter,
        employeeFilter: this.selectedEmployeeFilter,
        // bonusFilter: this.selectedbonusFilter,
        tradeFilter: this.selectedTradeFilter
      }
    },
    sortedShifts: function () {
      var dateGrouped = _.groupBy(this.shifts, (shift) => {
        return this.$moment(shift.startDatetime).format('YYYY-MM-DD')
      }) // groups all the same-date shifts together like:
      /*
      {
        2020-04-19: [
          shift1,
          shift2,
        ],
        2020-04-20: [
          shift1,
          shift2,
          shift3,
        ]
      }
      */

      var tradeSorted = _.each(dateGrouped, (shiftGroup, key) => { // for each group of shifts...
        dateGrouped[key] = _.sortBy(shiftGroup, (shift) => { // sort this subset of shifts and assign them back tion the date-grouped object
          if (shift.userId === this.user.id) {
            return -3
          }
          if (shift.tradePending) {
            return -2
          }
          return 0
        })
      })
      var sortedShifts = [];
      // go through the date-grouped object and pull out all the shfits in order,
      // pushing them into the empty array above
      _.each(tradeSorted, (shiftGroup) => {
        _.each(shiftGroup, (shift) => {
          sortedShifts.push(shift)
        })
      })
      return sortedShifts;
    },
  },
  methods: {
    updateFilters(e) {
      this.selectedStatusFilter = e['statusFilter']
      this.selectedPositionFilter = e['positionFilter']
      this.selectedLocationFilter = e['locationFilter']
      this.selectedEmployeeFilter = e['employeeFilter']
      this.selectedbonusFilter = e['bonusFilter']
      this.selectedTradeFilter = e['tradeFilter']

      this.reGetRecords()
    },

    hide (shift) {
      if (shift.userId == this.user.id) {
        return false; // never hide employee's shifts
      }

      if ( shift.tradeAcceptUserId && shift.tradeAcceptUserId != this.user.id ) {
        return true; // hide accepted trades that don't involve this user
      };

      return false; // show everything else for now
    },

    goToMonth: function () {
      // don't pass these dates into the calendar, but keep the other filters
      let query = {
        ...this.formattedQuery,
        startDate: undefined,
        endDate: undefined,
      }
      this.$router.push({
        name: 'month',
        query: query
      })
    },

    maybeGrey: function(shift) {
      // first, represent the shift in question in the same date format as workedDays's array:
      let shiftAsDate = this.$moment(shift.startDatetime).format("YYYY-MM-DD"); 
      // then, if this shift's date is included in that workedDays array, do something:
      if (this.workedDays.find(workedDate => workedDate == shiftAsDate)) {
        return "shift-on-day";
        // in this case, we're returning this bit to shove into the `style` attribute as a string
      }
    },

    reGetRecords: function () {
      this.$router.push({
        name: 'calendar',
        query: this.formattedQuery
      })
    },

    getShifts: function () {
      const params = this.formattedQuery

      this.shiftQueryPending = true
      this.$store.dispatch('shifts/getList', params)
      .then(res => {
        this.queryTotal = res.total
        this.shifts = res.shifts
      })
      .finally(res => {
        this.shiftQueryPending = false
      })

      inviteApi.getMineInRange({ from: params.startDate, to: params.endDate }, (events) => {
        this.events = events
      })

    },

    dateFormatted: function (date) {
      return this.$moment(date).format("YYYY-MM-DD")
    },

    setUp: function () {
      // use all dates and params in the url if any are present
      // otherwise, defaults are used from the component's data
      this.startDate = this.$route.query.startDate || this.startDate
      this.endDate = this.$route.query.endDate || this.endDate
      this.limit = parseInt(this.$route.query.limit) || this.limit
      this.page = parseInt(this.$route.query.page) || this.page
      this.selectedStatusFilter = this.$route.query.statusFilter || this.selectedStatusFilter
      this.selectedPositionFilter = parseInt(this.$route.query.positionFilter) || this.selectedPositionFilter
      this.selectedLocationFilter = parseInt(this.$route.query.locationFilter) || this.selectedLocationFilter
      this.selectedEmployeeFilter = parseInt(this.$route.query.employeeFilter) || this.selectedEmployeeFilter
      // this.selectedbonusFilter = this.$route.query.bonusFilter || this.selectedbonusFilter
      this.selectedTradeFilter = this.$route.query.tradeFilter || this.selectedTradeFilter

      this.$router.push({
        name: 'calendar',
        query: this.formattedQuery
      })

      this.getShifts()

      this.positionsLoading = true
      collectionApi.getPositions(positions => {
        this.positionFilters = positions
        this.positionsLoading = false
      },
        error => {
          console.log(error)
          this.positionsLoading = false
        }
      )

      this.locationsLoading = true
      collectionApi.getLocations(locations => {
        this.locationFilters = locations
        this.locationsLoading = false
      },
        error => {
          console.log(error)
          this.locationsLoading = false
        }
      )

      this.employeesLoading = true
      collectionApi.getEmployees(employees => {
        this.employeeFilters = employees
        this.employeesLoading = false
      },
        error => {
          console.log(error)
          this.employeesLoading = false
        }
      )

      // TODO: get all filter content
      // TODO: get all managers
      // this.$store.dispatch('serviceRequest/getOptions', this.user.id)

      // this.setNewDates(start, end)
      // this.setNewMonth(currentMonthName)
    },
    shiftStartTimeString: function (shift) {
      return this.$moment(shift.startDatetime).format("HH:MM")
    },

    shiftDuration: function (shift) {
      var start = this.$moment(shift.startDatetime)
      var end = this.$moment(shift.endDatetime)
      var duration = this.$moment.duration(end.diff(start))
      var minutes = duration.asMinutes()

      return minutes
    },
  },

  data: function() {
    return {
      queryTotal: null,
      limitOptions: [10, 25, 50, 100],
      limit: 10,
      page: 1,
      startDateMenu: false,
      endDateMenu: false,
      startDate: this.$moment().format("YYYY-MM-DD"),
      endDate: this.$moment().add(1, "week").format("YYYY-MM-DD"),
      shifts: [],
      events: [],
      shiftQueryPending: false,
      positionsLoading: false,
      locationsLoading: false,
      employeesLoading: false,
      statusFilters: [
        {
          text: 'All',
          value: 'employee-all',
        },
        {
          text: 'Available',
          value: 'available',
        },
        {
          text: 'Mine',
          value: 'assigned',
        },
      ],
      selectedStatusFilter: "employee-all",

      positionFilters: [],
      selectedPositionFilter: null,

      locationFilters: [],
      selectedLocationFilter: null,

      employeeFilters: [],
      selectedEmployeeFilter: null,

      // bonusFilterOptions: [
      //   {
      //     text: 'Straight Bonus',
      //     value: 'straightBonus'
      //   },
      //   {
      //     text: 'Call in Bonus',
      //     value: 'callInBonus'
      //   },
      //   {
      //     text: 'Travel Bonus',
      //     value: 'travelBonus'
      //   }
      // ],
      // selectedbonusFilter: null,
 
      selectedTradeFilter: null,



      // selectedMultiFilter: null,
      // selectedMultiFilterClient: null,
      // selectedMultiFilterEmployee: null,
      multiFilterOptions: [
        {
          text: 'By Client',
          value: 'clients',
        },
        {
          text: 'By Employee',
          value: 'employees',
        },
      ],
    }
  },
}
</script>

<style scoped>
#dashboard-container {
}

.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}

.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}

.pending-approval {
  opacity: 0.3;
  border: 1px dashed black !important;
  border-radius: 4px;
  padding: 4px;
}

.shift-overflow-count {
  position: absolute;
  top: 0px;
  right: 0px;
}

</style>

<style>
.vss-calendar.v-calendar.timeframe-week .v-calendar-daily__body {
  display: none !important;
}

.vss-calendar.v-calendar.timeframe-day .v-calendar-daily__body {
  display: none !important;
}

.vss-calendar .v-calendar-weekly__day {
  max-height: 140px !important;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
}

.vss-calendar .v-calendar-weekly__day::-webkit-scrollbar { width: 0 !important; }
.vss-calendar .v-calendar-weekly__day { overflow: -moz-scrollbars-none !important; }
.vss-calendar .v-calendar-weekly__day { -ms-overflow-style: none !important; }

.shift-overflow-count .v-chip__content {
  cursor: pointer !important;
}

.shift-details-icon {
  cursor: default;
}

.shift-on-day {
  opacity: 0.2;
}
</style>
